
import { defineComponent, ref, onBeforeMount } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import CryptoJS from "crypto-js";
import { useStore } from "vuex";

export default defineComponent({
  name: "email",

  components: {
    Field,
    Form,
    ErrorMessage,
  },

  setup() {

    console.log('NODE_ENV =', process.env.NODE_ENV);
    const distribuidor = "";
    const router = useRouter();
    const route = useRoute(); // Captura os parâmetros da rota
    const store = useStore();
    const emailClient = ref(route.query.email || '');
    const token = ref(route.query.token || '');

    // O resto do seu setup permanece o mesmo
    // console.log("Token:", token.value);  // Apenas para verificar que o token está sendo capturado corretamente
    // console.log("Email:", emailClient.value);
    const linkIOS = ref("https://apps.apple.com/br/app/indicar/id1573980796");
    const linkAndroid = ref(
      "https://play.google.com/store/apps/details?id=br.com.camptecnologia.indicar&hl=pt_BR&gl=US&pli=1"
    );
    const fullscreenLoading = ref(false);


    const submitButton = ref<HTMLElement | null>(null);

    // Create form validation object
    const emailSchema = Yup.object().shape({
      email: Yup.string()
        .email("E-mail deve ser valido")
        .required("Informe e-mail")
        .label("E-mail"),
      password: Yup.string()
        .min(4, "Deve ser maior que ${min}")
        .required("Informe a nova senha")
        .label("Senha"),
      password_confirmation: Yup.string()
        .min(4, "Deve ser maior que ${min}")
        .oneOf([Yup.ref('password')], 'As senhas não coincidem')
        .required("Confirme a senha")
        .label("Senha"),
    });

    //Form submit function
    const onSubmitNewPass = (values) => {
      // values.email = CryptoJS.MD5(values.email.toLowerCase()).toString();
      // values.senha = CryptoJS.MD5(values.senha.toLowerCase()).toString();


      values.email = values.email.toLowerCase().toString();
      values.password_confirmation =  values.password_confirmation.toString();
      values.token = token.value;


      if (submitButton.value) {
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
        submitButton.value.setAttribute("disabled", "disabled");
      }

      // Send recovery request
      store
        .dispatch(Actions.REDEFINICAO, values)
        .then((response) => {
          submitButton.value?.removeAttribute("data-kt-indicator");
          submitButton.value?.removeAttribute("disabled");
          Swal.fire({
            text: response.msg,
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        })
        .catch(() => {
          //Deactivate indicator
          submitButton.value?.removeAttribute("data-kt-indicator");
          submitButton.value?.removeAttribute("disabled");
          Swal.fire({
            text: store.getters.getErrors,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Tente novamente!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          }).then(() => {
            router.push({ name: "recuperarSenha" });
          });;
        });
    };

    return {
      onSubmitNewPass,
      emailSchema,
      emailClient,
      token,
      submitButton,
      fullscreenLoading,
      distribuidor,
      linkAndroid,
      linkIOS,
    };
  },
});
